/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_In_To_Manage_NotificationsInputs */

const th_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบเพื่อเลือกเรื่องที่ต้องการรับแจ้งและช่องทางที่ใช้`)
};

const en_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to choose what you are told about, and how.`)
};

const ja_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何をどの方法で通知するか選ぶにはログインしてください。`)
};

const zh_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后可选择想收到哪些消息，以及通过什么方式。`)
};

const es_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para elegir de qué quieres enterarte, y cómo.`)
};

const pt_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para escolher sobre o que quer ser avisado, e como.`)
};

const id_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk memilih apa yang ingin Anda dengar dan lewat mana.`)
};

const fr_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour choisir ce dont vous êtes informé, et comment.`)
};

const tl_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-sign in para piliin ang nais mong mabalitaan at kung paano.`)
};

const vi_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập để chọn bạn muốn nghe gì và qua kênh nào.`)
};

const ko_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 소식을 어떤 방법으로 받을지 고르려면 로그인하세요.`)
};

const de_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich an, um zu wählen, worüber du informiert wirst und wie.`)
};

const ru_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, чтобы выбрать, о чём и как вас уведомлять.`)
};

const tr_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neyi ve nasıl duyacağınızı seçmek için giriş yapın.`)
};

const it_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per scegliere di cosa vuoi essere avvisato e come.`)
};

const pl_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, aby wybrać, o czym i jak chcesz wiedzieć.`)
};

const uk_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійдіть, щоб обрати, про що і як вас сповіщати.`)
};

const hi_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह चुनने के लिए साइन इन करें कि आप क्या और कैसे जानना चाहते हैं।`)
};

const ar_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول لتختار ما تريد معرفته وكيف.`)
};

const ms_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk untuk memilih apa yang anda mahu tahu dan bagaimana.`)
};

const bn_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কী এবং কীভাবে জানতে চান তা বেছে নিতে সাইন ইন করুন।`)
};

const zh_tw2_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可選擇想收到哪些消息，以及透過什麼方式。`)
};

const zh_hk2_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可選擇想收到哪些消息，以及透過什麼方式。`)
};

const ur_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کیا اور کیسے جاننا چاہتے ہیں، یہ چننے کے لیے سائن اِن کریں۔`)
};

const fa_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برای برگزیدن اینکه چه چیزی و چگونه بدانید وارد شوید.`)
};

const sw_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia ili kuchagua unachotaka kujua na jinsi gani.`)
};

const nl_sign_in_to_manage_notifications = /** @type {(inputs: Sign_In_To_Manage_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in om te kiezen waarover en hoe je bericht krijgt.`)
};

/**
* | output |
* | --- |
* | "Sign in to choose what you are told about, and how." |
*
* @param {Sign_In_To_Manage_NotificationsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_in_to_manage_notifications = /** @type {((inputs?: Sign_In_To_Manage_NotificationsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_In_To_Manage_NotificationsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sign_in_to_manage_notifications(inputs)
	if (locale === "ja") return ja_sign_in_to_manage_notifications(inputs)
	if (locale === "zh") return zh_sign_in_to_manage_notifications(inputs)
	if (locale === "es") return es_sign_in_to_manage_notifications(inputs)
	if (locale === "pt") return pt_sign_in_to_manage_notifications(inputs)
	if (locale === "id") return id_sign_in_to_manage_notifications(inputs)
	if (locale === "fr") return fr_sign_in_to_manage_notifications(inputs)
	if (locale === "tl") return tl_sign_in_to_manage_notifications(inputs)
	if (locale === "vi") return vi_sign_in_to_manage_notifications(inputs)
	if (locale === "ko") return ko_sign_in_to_manage_notifications(inputs)
	if (locale === "de") return de_sign_in_to_manage_notifications(inputs)
	if (locale === "ru") return ru_sign_in_to_manage_notifications(inputs)
	if (locale === "tr") return tr_sign_in_to_manage_notifications(inputs)
	if (locale === "it") return it_sign_in_to_manage_notifications(inputs)
	if (locale === "pl") return pl_sign_in_to_manage_notifications(inputs)
	if (locale === "uk") return uk_sign_in_to_manage_notifications(inputs)
	if (locale === "hi") return hi_sign_in_to_manage_notifications(inputs)
	if (locale === "ar") return ar_sign_in_to_manage_notifications(inputs)
	if (locale === "ms") return ms_sign_in_to_manage_notifications(inputs)
	if (locale === "bn") return bn_sign_in_to_manage_notifications(inputs)
	if (locale === "zh-TW") return zh_tw2_sign_in_to_manage_notifications(inputs)
	if (locale === "zh-HK") return zh_hk2_sign_in_to_manage_notifications(inputs)
	if (locale === "ur") return ur_sign_in_to_manage_notifications(inputs)
	if (locale === "fa") return fa_sign_in_to_manage_notifications(inputs)
	if (locale === "sw") return sw_sign_in_to_manage_notifications(inputs)
	if (locale === "nl") return nl_sign_in_to_manage_notifications(inputs)
	return en_sign_in_to_manage_notifications(inputs)
});